import React, { useCallback, useEffect, useState } from "react";
import TrendingRow from "../../../../components/TrendingRow/TrendingRow";
import { IState, Item } from "../../../../interfaces/interfaces";
import SectionItems from "../../../../components/SectionItems/SectionItems";
import API from "../../../../api/api";
import { useDispatch, useSelector } from "react-redux";
import {
  addRecommendedItems,
  addTrendingItems,
} from "../../../../store/actions/ItemActions";
import { EParams } from "../../../../interfaces/enum";
import { useSearchParams } from "react-router-dom";

const Home = () => {
  const [params] = useSearchParams({});
  const q = params.get(EParams.QUERY);
  const { trendingItems, recommendedItems } = useSelector(
    (state: IState) => state.item
  );
  const [loading, setLoading] = useState(recommendedItems.length === 0);
  const dispatch = useDispatch();

  const callTrendingItems = useCallback(() => {
    if (trendingItems.length !== 0) return;
    API.getTrendingItems().then((res) => {
      setTimeout(() => {
        dispatch(addTrendingItems(res as Item[]));
      }, 1500);
    });
  }, [trendingItems.length, dispatch]);

  const callRecommendedItems = useCallback(() => {
    if (recommendedItems.length !== 0) return;
    API.getRemainingItems().then((res) => {
      setTimeout(() => {
        dispatch(addRecommendedItems(res as Item[]));
        setLoading(false);
      }, 2500);
    });
  }, [recommendedItems.length, dispatch]);

  useEffect(() => {
    callTrendingItems();
    callRecommendedItems();
  }, [callRecommendedItems, callTrendingItems]);

  return (
    <div className="w-100">
      {!q && <TrendingRow items={trendingItems} />}
      <SectionItems
        title={"Recommended Items"}
        items={recommendedItems}
        isTrending={false}
        loading={loading}
      />
    </div>
  );
};

export default Home;
